import React from 'react';
import '../style/pagination.css'

const Pagination = (props) => {
    let renderComp;
    if (props.TotalDisplayBoxes <= 5) {
        renderComp = [1, 2, 3, 4, 5].slice(0, props.TotalDisplayBoxes).map((value) =>
            props.Page === value ?
                <div className="pagination-box-active" key={value}
                     onClick={() => {
                         props.HandleInputChange('page', value);
                     } }>
                    <span>{value}</span></div>
                :
                <div className="pagination-box" key={value}
                     onClick={() => {
                         props.HandleInputChange('page', value);
                     }}>
                    <span>{value}</span></div>)
    }
    else if (props.TotalDisplayBoxes === 6) {
        renderComp = [1, 2, 3, 4, 5, 6].slice(0, props.TotalDisplayBoxes).map((value) =>
            props.Page === value ?
                <div className="pagination-box-active" key={value}
                     onClick={() => {
                         props.HandleInputChange('page', value);
                     } }>
                    <span>{value}</span></div>
                :
                <div className="pagination-box" key={value}
                     onClick={() => {
                         props.HandleInputChange('page', value);
                     }}>
                    <span>{value}</span></div>)
    }
    else if ( props.TotalDisplayBoxes>=1 && props.Page <5){
        renderComp = <div style={{position: 'relative', display: 'inline-block'}}>
            {
                [1,2,3,4,5].slice(0,props.TotalDisplayBoxes).map((value) =>
                    props.Page === value ?
                        <div className="pagination-box-active" key={value}
                             onClick={() => {
                                 props.HandleInputChange('page', value);
                             } }>
                            <span>{value}</span></div>
                        :
                        <div className="pagination-box" key={value}
                             onClick={() => {
                                 props.HandleInputChange('page', value);
                             }}>
                            <span>{value}</span></div>)
            }
            <div className="agents-list-footer-dot-box">
                <span>...</span>
            </div>
            {
                props.Page === props.TotalDsplayBoxes ?
                    <div className="agents-list-footer-arrow-box-2"
                         onClick={() => props.HandleInputChange('page', props.TotalDisplayBoxes) }>
                        <span>{props.TotalDisplayBoxes}</span>
                    </div>
                    :
                    <div className="agents-list-footer-arrow-box"
                         onClick={() => props.HandleInputChange('page', props.TotalDisplayBoxes) }>
                        <span>{props.TotalDisplayBoxes}</span>
                    </div>
            }
        </div>
    }
    else if (props.Page >= props.TotalDisplayBoxes - 3 ){
        renderComp = <div style={{position: 'relative', display: 'inline-block'}}>
            <div className="pagination-box"
                 onClick={() => props.HandleInputChange('page', 1) }>
                <span>1</span>
            </div>
            <div className="pagination-box-more">
                <span>...</span>
            </div>
            {
                [props.TotalDisplayBoxes -4, props.TotalDisplayBoxes -3 , props.TotalDisplayBoxes -2, props.TotalDisplayBoxes -1, props.TotalDisplayBoxes].map((value) =>
                    props.Page === value ?
                        <div className="pagination-box-active" key={value}
                             onClick={() => {
                                 props.HandleInputChange('page', value);
                             } }>
                            <span>{value}</span></div>
                        :
                        <div className="pagination-box" key={value}
                             onClick={() => {
                                 props.HandleInputChange('page', value);
                             }}>
                            <span>{value}</span></div>)
            }
        </div>
    }
    else if (props.Page >4 && props.Page <= props.TotalDisplayBoxes - 4){
        renderComp = <div style={{position: 'relative', display: 'inline-block'}}>
            {
                props.Page === props.TotalDisplayBoxes ?
                    <div className="pagination-box-active"
                         onClick={() => props.HandleInputChange('page', 1) }>
                        <span>1</span>
                    </div>
                    :
                    <div className="pagination-box"
                         onClick={() => props.HandleInputChange('page', 1) }>
                        <span>1</span>
                    </div>
            }
            <div className="pagination-box-more">
                <span>...</span>
            </div>
            {
                [ props.Page -1, props.Page  , props.Page  +1].map((value) =>
                    props.Page === value ?
                        <div className="pagination-box-active" key={value}
                             onClick={() => {
                                 props.HandleInputChange('page', value);
                             } }>
                            <span>{value}</span></div>
                        :
                        <div className="pagination-box" key={value}
                             onClick={() => {
                                 props.HandleInputChange('page', value);
                             }}>
                            <span>{value}</span></div>)
            }
            <div className="pagination-box-more">
                <span>...</span>
            </div>
            {
                props.Page === props.TotalDisplayBoxes ?
                    <div className="pagination-box-active"
                         onClick={() => props.HandleInputChange('page', props.TotalDisplayBoxes) }>
                        <span>{props.TotalDisplayBoxes}</span>
                    </div>
                    :
                    <div className="pagination-box"
                         onClick={() => props.HandleInputChange('page', props.TotalDisplayBoxes) }>
                        <span>{props.TotalDisplayBoxes}</span>
                    </div>
            }
        </div>
    }
    else  renderComp = null;

    return (
        <div className="row">
            <div className="col-lg-3 pagination-display-message-wrapper">
                {
                    props.TotalRecords === 0?
                        <span className="pagination-display-message">Showing 0-0 from 0</span>
                        :
                        props.TotalDisplayBoxes !== props.Page ?
                            <span className="pagination-display-message">Showing {(props.Page - 1) * (props.SelectedView) + 1}-{(props.Page - 1) * (props.SelectedView) + props.SelectedView} from {props.TotalRecords}</span>
                            :
                            <span className="pagination-display-message">Showing {(props.Page - 1) * (props.SelectedView)+1}-{props.TotalRecords } from {props.TotalRecords}</span>
                }
            </div>
            <div className="col-lg-6 pagination-boxes-wrapper">
                <div className="pagination-box pagination-box-left" onClick={() => props.PageShift('left',props.TotalDisplayBoxes)}>
                    <svg className="pagination-box-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.2 12">
                        <title>Asset 2</title>
                        <g id="Layer_2" data-name="Layer 2">
                            <g id="info">
                                <path
                                    d="M0,6.06a1.22,1.22,0,0,0,.36.87l4.73,4.71A1.22,1.22,0,0,0,6.81,9.91L2.94,6.05l3.91-4A1.22,1.22,0,1,0,5.11.36L.35,5.2A1.22,1.22,0,0,0,0,6.06Z"/>
                            </g>
                        </g>
                    </svg>
                </div>
                {renderComp}
                <div className="pagination-box pagination-box-right" onClick={() => props.PageShift('right', props.TotalDisplayBoxes)}>
                    <svg className="pagination-box-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.2 12">
                        <title>Asset 1</title>
                        <g id="Layer_2" data-name="Layer 2">
                            <g id="info">
                                <path
                                    d="M7.2,5.94a1.22,1.22,0,0,0-.36-.87L2.11.36A1.22,1.22,0,0,0,.39,2.09L4.26,5.95l-3.91,4a1.22,1.22,0,1,0,1.74,1.72L6.85,6.8a1.22,1.22,0,0,0,.35-.86Z"/>
                            </g>
                        </g>
                    </svg>
                </div>
            </div>
            <div className="col-lg-3"></div>
        </div>
    )
};

export default Pagination;